var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoy3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 464.001 464.001",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M391.863,422.878l-0.726-6.536c-0.287-2.586-2.616-4.449-5.201-4.162l-0.407,0.045l-7.027-56.214   c-1.529-12.228-9.943-22.491-21.633-26.389l-51.75-17.25c-1.039,2.343-2.19,4.629-3.44,6.854l-10.738-3.579   c-6.534-2.178-10.94-8.292-10.94-15.179v-25.802l34.461-14.359C332.349,252.855,344,235.378,344,216v-8c13.255,0,24-10.745,24-24   s-10.745-24-24-24v-16c0-22.091-17.909-40-40-40H160c-22.092,0-40,17.909-40,40v16c-13.255,0-24,10.745-24,24s10.745,24,24,24v8   c0,19.377,11.651,36.854,29.538,44.308L184,274.668v25.801c0,6.887-4.407,13.001-10.94,15.179l-10.738,3.579   c-1.25-2.225-2.401-4.51-3.44-6.854l-51.75,17.25c-11.691,3.897-20.105,14.161-21.633,26.389l-7.027,56.214l-0.407-0.045   c-2.585-0.287-4.914,1.576-5.201,4.162l-0.726,6.536c-0.287,2.585,1.576,4.914,4.161,5.201l11.702,1.3v18.621   c0,8.837,7.164,16,16,16h40h176h40c8.837,0,16-7.163,16-16V429.38l11.702-1.3C390.287,427.792,392.151,425.463,391.863,422.878z",
    fill: "#6f5139",
    "data-original": "#f6b47b",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M343.979,56.209c0-0.071,0.021-0.137,0.021-0.208c0-22.091-17.909-40-40-40   c-6.219,0-12.033,1.541-17.282,4.073C280.127,12.717,270.655,8,260,8c-5.583,0-10.804,1.379-15.52,3.647   C240.277,4.695,232.718,0,224,0c-9.605,0-17.829,5.68-21.665,13.831C197.137,10.181,190.835,8,184,8   c-13.396,0-24.836,8.247-29.605,19.928C151.593,25.513,147.99,24,144,24c-8.836,0-16,7.163-16,16c0,0-40-0.333-40,48   c0,22.526,16,88,16,88h256c0,0,8-37,8-88C368,74.142,355.123,63.141,343.979,56.209z",
    fill: "#201e1e",
    "data-original": "#734a3e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M219.297,127.526C199.449,125.172,184,108.481,184,88c0-20.59,15.616-37.348,35.617-39.558   C217.34,43.415,216,37.877,216,32c0-12.542,5.855-23.605,14.906-30.897C228.713,0.432,226.419,0,224,0   c-9.605,0-17.829,5.68-21.665,13.831C197.137,10.181,190.835,8,184,8c-13.396,0-24.836,8.247-29.605,19.928   C151.593,25.513,147.99,24,144,24c-8.836,0-16,7.163-16,16c0,0-40-0.333-40,48c0,22.526,16,88,16,88h115L219.297,127.526z",
    fill: "#nannannan",
    "data-original": "#5e342e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M280,274.001h-96v26.468c0,5.759-3.186,10.831-8.017,13.659   C243.077,325.871,280,274.001,280,274.001z",
    fill: "#553d2d",
    "data-original": "#e2a071",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M344,160v-16c0-22.091-17.909-40-40-40H160c-22.092,0-40,17.909-40,40v16c-13.255,0-24,10.745-24,24   s10.745,24,24,24v8c0,19.377,11.651,36.854,29.538,44.308l51.691,21.538c9.75,4.063,20.208,6.154,30.77,6.154l0,0   c10.562,0,21.019-2.091,30.769-6.154l51.694-21.539C332.349,252.855,344,235.378,344,216v-8c13.255,0,24-10.745,24-24   S357.255,160,344,160z",
    fill: "#8b6449",
    "data-original": "#fdc88e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M176,192L176,192c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v8   C184,188.4,180.4,192,176,192z",
    fill: "#3a2822",
    "data-original": "#623f33",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M288,192L288,192c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v8   C296,188.4,292.4,192,288,192z",
    fill: "#3a2822",
    "data-original": "#623f33",
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M232,248.219c-14.223,0-27.527-3.5-36.5-9.605c-3.652-2.484-4.602-7.461-2.113-11.113    c2.48-3.648,7.461-4.598,11.113-2.113c6.289,4.277,16.57,6.832,27.5,6.832s21.211-2.555,27.5-6.832    c3.66-2.492,8.629-1.539,11.113,2.113c2.488,3.652,1.539,8.629-2.113,11.113C259.528,244.719,246.223,248.219,232,248.219z",
    fill: "#553d2d",
    "data-original": "#e2a071",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M161.996,243.723c-6.482-6.95-9.995-16.121-9.995-25.625V104.806c-18.257,3.707-32,19.843-32,39.194   v16c-13.255,0-24,10.745-24,24s10.745,24,24,24v8c0,19.378,11.651,36.855,29.538,44.308l51.69,21.538   c2.53,1.054,5.112,1.962,7.727,2.749C186.111,267.883,170.905,253.275,161.996,243.723z",
    fill: "#6f5139",
    "data-original": "#f6b47b",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M378.502,356.012c-1.529-12.228-9.943-22.491-21.633-26.389l-51.75-17.25L256,344l-16,16   c-3.25,0-12.167,0-16,0l-16-16l-49.119-31.628l-51.75,17.25c-11.691,3.897-20.105,14.161-21.633,26.389l-7.609,60.872l66.11,7.117   v40h176v-40h67L378.502,356.012z",
    fill: "#1c2e93",
    "data-original": "#43a0c5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M144,430.04v-18.106c0-7.697-2.774-15.135-7.813-20.953l-44.019-50.813   c-3.552,4.497-5.93,9.93-6.669,15.843l-8.356,66.847C89.867,423.622,123.711,427.587,144,430.04z",
    fill: "#1aa3db",
    "data-original": "#2c8cb3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M144,419.507l-65.936-7.326c-2.586-0.287-4.914,1.576-5.202,4.161l-0.726,6.536   c-0.287,2.585,1.576,4.914,4.161,5.201L144,435.602V419.507z",
    fill: "#1179a2",
    "data-original": "#1179a2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M320,430.04v-18.106c0-7.697,2.774-15.135,7.813-20.953l44.019-50.813   c3.552,4.497,5.93,9.93,6.669,15.843l8.356,66.847C374.134,423.622,340.289,427.587,320,430.04z",
    fill: "#1aa3db",
    "data-original": "#2c8cb3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M320,419.507l65.936-7.326c2.586-0.287,4.914,1.576,5.202,4.161l0.726,6.536   c0.287,2.585-1.576,4.914-4.161,5.201L320,435.602V419.507z",
    fill: "#1179a2",
    "data-original": "#1179a2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M180.438,302.657L208,344l-24,32l-32-64l17.344-11.562   C173.02,297.987,177.987,298.98,180.438,302.657z",
    fill: "#1aa3db",
    "data-original": "#2c8cb3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M283.563,302.657L256,344l24,32l32-64l-17.344-11.562   C290.98,297.987,286.014,298.98,283.563,302.657z",
    fill: "#1aa3db",
    "data-original": "#2c8cb3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M232,424L232,424c-4.418,0-8-3.582-8-8v-56h16v56C240,420.419,236.419,424,232,424z",
    fill: "#1aa3db",
    "data-original": "#2c8cb3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M332,72c-4.516,0-8.72,1.169-12.497,3.068C317.048,55.331,300.402,40,280,40   c-13.996,0-26.273,7.215-33.421,18.101C243.312,56.765,239.749,56,236,56s-7.312,0.765-10.579,2.101   C218.274,47.215,205.996,40,192,40c-22.091,0-40,17.909-40,40s17.909,40,40,40c11.4,0,21.625-4.824,28.911-12.475   c4.361,2.803,9.52,4.475,15.089,4.475s10.729-1.672,15.089-4.475C258.376,115.176,268.6,120,280,120   c9.97,0,18.975-3.78,25.979-9.814C310.06,120.599,320.141,128,332,128c15.464,0,28-12.536,28-28S347.464,72,332,72z",
    fill: "#201e1e",
    "data-original": "#734a3e",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 159,
    cy: 83.001,
    r: 38,
    fill: "#nannannan",
    "data-original": "#5e342e",
    className: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy3);
export default __webpack_public_path__ + "static/media/boy3.604b3f1775346f876d3b53c04754e4f8.svg";
export { ForwardRef as ReactComponent };